/**
 * Legacy UserApiService module — preserved as an empty AngularJS module so
 * existing dependencies (`acme.common.service.userApi`) keep resolving.
 *
 * The actual `UserApiService` factory is now registered in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts (indirectly,
 * through the ApiService facade). The Angular 18 implementation lives at
 * apps/b2b-frontend/app/core/api/user/user-api.service.ts.
 *
 * Do NOT register `.service('UserApiService', ...)` here — `apiService.user`
 * is now an Angular 18 `inject(UserApiService)`, not a `$injector.get(...)`
 * bridge, so the legacy registration would be dead code.
 */
angular.module('acme.common.service.userApi', ['acme.common.factory.apiVersion']);
